import {
  Button,
  InputNumber,
  Spin,
  message,
  Tag,
  Modal,
  Input,
  Tabs,
  Select,
  DatePicker,
} from "antd";
import React, { useState } from "react";
import { useCallback, useEffect } from "react";

import { format } from "../../App";
import MenuBar from "../menu/MenuBar";

import { useSelector, useDispatch } from "react-redux";
import { gotoMakePDF } from "./gotoPDF";
import { useHistory } from "react-router-dom";
import { delUser, setUser } from "../../app/features/user/userSlice";
import moment from "moment";

import { postData, pad, getOptionDriver } from "../../data/allfunction";

import MakeDocLong from "../pdf/MakeDocLong";
import MakeDocSafty from "../pdf/MakeDocSafty";
import ShowModalPolicy from "../modalPolicy/ShowModalPolicy";

const dateFormat = "DD-MM-YYYY HH:mm:ss";
const ip = process.env.REACT_APP_IP;
const QR = process.env.REACT_APP_QR;
const { TextArea } = Input;
const { TabPane } = Tabs;

function ConfirmPaidLate() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { user_id, user, token, retoken, level } = useSelector((state) => {
    return state.user;
  });

  const [policy_no, setpolicy_no] = useState(0);
  const [loading, setloading] = useState(false);
  const [oneData, setoneData] = useState({});

  const [detial, setdetial] = useState("");

  const [no, setno] = useState(null);




  const [enablePayLate, setenablePayLate] = useState(false);
  // const [detialPaylate, setdetialPaylate] = useState("");


  const [modal_setswitchStatus__ConfirmS, sets_modalwitchStatus_ConfirmS] = useState(false);
  const [switchStatus_ConfirmS_data, setswitchStatus_ConfirmS_data] = useState({});

  const [modal_show_alldetail, setmodal_show_alldetail] = useState(false);



  const [thirdcover_option, setthirdcover_option] = useState([]);
  const [drivercover_option, setdrivercover_option] = useState([]);
  const [getOneFull, setgetOneFull] = useState({});

  //ດິງຂໍ້ມູນປະເພດ ອ້ອບຊັ່ນບຸກຄຸນທີສາມ
  useEffect(() => {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    fetch(ip + "sell_online/thirdcover_option", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setthirdcover_option(result.data.data);
      })
      .catch((error) => console.log("error", error));
  }, []);
  //ດິງຂໍ້ມູນປະເພດ ອ້ອບຊັ່ນຜູ້ຂັບຂີ່
  // useEffect(() => {
  //   var requestOptions = {
  //     method: "GET",
  //     redirect: "follow",
  //   };

  //   fetch(ip + "sell_online/drivercover_option", requestOptions)
  //     .then((response) => response.json())
  //     .then((result) => {
  //       setdrivercover_option(result.data.data);
  //     })
  //     .catch((error) => console.log("error", error));
  // }, []);



  //ຟັ່ງຊັນບັນທຶກອະນຸຍາດໃຫ້ຈ່າຍຊ້າ
  const confirmFullCommit = () => {
    setenablePayLate(false);
    setdetial("");
    let link = `${ip}sell_online/confirmFullcomit`;
    let dataSetForGet = {
      detial: moment(Date.now()).format(dateFormat) + "=> ອະນຸຍາດຈ່າຍຊ້່າ//" + detial,
      confirm_user: user,
      no: no,
    };
    function setWhenUpdate(result) {
      if (result.data.data.changedRows === 1) {
        message.info("ຢືນຢັນສຳເຫຼັ້ດ");
        setoneData({});
        getOneData();
      } else {
        message.error("ເກີດຂໍ້ຜິດພາດ ກະລຸນາລອງໃໝ່");
      }
    }
    console.log(dataSetForGet)
    postData(
      message,
      link,
      dataSetForGet,
      token,
      retoken,
      user,
      dispatch,
      delUser,
      setUser,
      history,
      setWhenUpdate
    );
  };

  function getOneData() {
    let link = `${ip}sell_online/getOne`;
    let dataSetForGet = { no: policy_no, user: user_id };
    function setWhenUpdate(result) {
      if (result.data.status === 200) {
        const { rows } = result.data;
        // console.log(143)
        // console.log(rows)
        if (rows.length > 0) {
          setoneData(rows[0]);
        } else {
          setoneData({});
          message.success(`ບໍ່ພົບເລກທີສັນຍາ ${policy_no} ໃນລະບົບ`);
        }
        setTimeout(() => {
          setloading(false);
        }, 100);
      } else {
        setTimeout(() => {
          setloading(false);
        }, 100);
      }
    }
    postData(
      message,
      link,
      dataSetForGet,
      token,
      retoken,
      user,
      dispatch,
      delUser,
      setUser,
      history,
      setWhenUpdate
    );
  }


  function showModalDetail(no) {
    setno(no);
    setmodal_show_alldetail(true);
    getDataOneFull(no);
  }
  function getDataOneFull(no) {
    console.log("getDataOneFull");
    let link = `${ip}sell_online/getOneFull`;
    let dataSetForGet = { no: no };
    function setWhenUpdate(result) {
      setloading(true);
      if (result.data.status === 200) {
        const { rows } = result.data;
        if (rows.length > 0) {
          // let de = rows.map((e) => {
          //   return e       
          // });
          setgetOneFull(rows[0]);
        } else {
          setgetOneFull({});
        }
        setTimeout(() => {
          setloading(false);
        }, 100);
      } else {
        setTimeout(() => {
          setloading(false);
        }, 100);
      }
    }
    postData(
      message,
      link,
      dataSetForGet,
      token,
      retoken,
      user,
      dispatch,
      delUser,
      setUser,
      history,
      setWhenUpdate
    );
  }
  function callback(key) {
    // console.log(key);
  }
  //   useEffect(() => {
  // getUser();
  //   }, [getUser]);

  return (
    <>
      <MenuBar />
      <div className="container text-center mt-3">
        <h4>
          ຢືນຢັນການຮັບເງິນ ສັນຍາ ປະກັນໄພລົດ
        </h4>
      </div>
      <div
        className="container-fluid"
        style={{
          paddingBottom: 10,
        }}
      >
        <Tabs defaultActiveKey="1" onChange={callback}>
          <TabPane tab="ອະນຸຍາດໃຫ້ຈ່າຍຊ້າ" key="1">
            {Confirmfull()}
          </TabPane>
        </Tabs>
      </div>

      {/* ສະແດງພີດີເອຟ */}
      <Modal
        width={800}
        title={"ລາຍລະອຽດຂອງສັນຍາເລກທີ " + pad(switchStatus_ConfirmS_data.no)}
        visible={modal_setswitchStatus__ConfirmS}
        onOk={() => sets_modalwitchStatus_ConfirmS(false)}
        onCancel={() => sets_modalwitchStatus_ConfirmS(false)}
        footer={[
          <Button
            key="back"
            onClick={() => sets_modalwitchStatus_ConfirmS(false)}
          >
            ກັບຄືນ
          </Button>,
        ]}
      >
        <>
          <div></div>
          {gotoMakePDF(switchStatus_ConfirmS_data.cover) === "L" ? (
            <MakeDocLong
              no={switchStatus_ConfirmS_data.no}
              user={user}
              oneData={switchStatus_ConfirmS_data}
              thirdcover_option={thirdcover_option}
              drivercover_option={drivercover_option}
            />
          ) : (
            <MakeDocSafty
              no={switchStatus_ConfirmS_data.no}
              oneData={switchStatus_ConfirmS_data}
            />
          )}
        </>
      </Modal>
      {/* ສະແດງລາຍລະອຽດສັນຍາ/ */}


      <ShowModalPolicy
        no={no}
        modal_show_alldetail={modal_show_alldetail}
        setmodal_show_alldetail={setmodal_show_alldetail}
        getOneFull={getOneFull}
      />

    </>
  );

  function Confirmfull() {
    return (
      <div className="container-fluid">
        {loading && (
          <div
            style={{
              position: "absolute",
              top: "11%",
              left: "45%",
            }}
          >
            <Spin tip="ກຳລັງໂຫລດຂໍ້ມູນ..." />
          </div>
        )}

        <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ flex: 4 }}>
            <InputNumber
              style={{ width: "100%" }}
              onChange={(v) => setpolicy_no(v)}
              placeholder="ໃສ່ເລກທີສັນຍາ"
            />
          </div>
          <div style={{ flex: 1, marginLeft: 5 }}>
            <Button
              disabled={policy_no > 0 ? false : true}
              onClick={() => {
                getOneData();
              }}
              style={{ width: "100%" }}
              type="primary"
            >
              {" "}
              ຄົ້ນຫາ{" "}
            </Button>
          </div>
        </div>
        <table className="table table-striped">
          <thead>
            <tr>
              <th>#</th>
              <th>ຕົວແທນຂາຍ</th>
              <th>ເລກທີສັນຍາ</th>
              <th>ເລກທະບຽນ</th>
              <th>ວັນທີສິ້ນສຸດການຄຸ້ມກັນ</th>
              <th>ຊື່ລູກຄ້າ</th>
              <th>ລາຍຮັບທັງໝົ້ດ</th>
              <th>ກ່ອນອາກອນ</th>
              <th>ເປີເຊັນຕົວແທນ (ຄ່າຄອມ-ຈ່າຍຊ້າ)</th>
              <th>ເງິນຝາກຄັງ</th>
              <th>
                ລາຍຮັບຕົວແທນຫັກອາກອນແລ້ວ</th>
              <th>ລາຍຮັບເຂົ້າ ZJI</th>
              <th>ມອບເຂົ້າ ZJI ສຸດທິ</th>
              <th>ວັນທີຄ້າງຈ່າຍ</th>
              <th>ສະຖານະການຊຳລະໃຫ້ຕົວແທນ</th>
              <th>ສະຖານະການຊຳລະໃຫ້ສຳນັກງານ</th>
              <th>ສະຖານະຂອງສັນຍາ</th>
            </tr>

          </thead>
          {oneData.no && (
            <tbody>
              <tr>
                <td>{1}</td>
                <td>{oneData.userText}</td>
                <td>

                  <Button
                    onClick={() => {
                      sets_modalwitchStatus_ConfirmS(true);
                      setswitchStatus_ConfirmS_data(oneData);
                      getOptionDriver(oneData, setdrivercover_option)
                    }}
                  >
                    {oneData.policy_type === 'MS' ? 'MS-' : null}{pad(oneData.no)}
                  </Button>
                </td>
                <td>{oneData.o_plate}</td>
                <td>{moment(oneData.end).format("DD-MM-YYYY HH:mm:ss")}</td>
                <td>{oneData.o_name}</td>
                <td style={{ textAlign: "right" }}>
                  {format(oneData.total_premuim)}
                </td>
                <td style={{ textAlign: 'right' }}>
                  {/* ກ່ອນອາກອນ */}
                  {format(oneData.premuim)}
                </td>
                <td style={{ textAlign: "right", ...(oneData.enable_pay_late === 1 ? { color: "orange" } : {}) }}>
                  {/* ເປີເຊັນຕົວແທນ */}
                  {/* {oneData.Total_MVL}  */}
                  (
                  {
                    oneData.paid === 1 ? oneData.commission_percen : format(oneData.Total_MVL) + "-" + oneData.paylate
                  }
                  )% =
                  {
                    format(oneData.agentCommit)
                  }
                </td>
                <td style={{ textAlign: "right" }}>
                  {/* ເງິນຝາກຄັງ */}

                  {oneData.paid === 1 ? oneData.diposit_percen : (oneData.Diposit)}% =  {format(oneData.depos)}

                </td>
                <td style={{ textAlign: 'right' }}>
                  {/* ຫັກອາກອນ 5  % */}
                  {
                    format(oneData.Text116)
                  }
                  % =
                  {
                    format(oneData.tex)
                  }
                </td>
                <td style={{ textAlign: 'right' }}>
                  {/* ລາຍຮັບເຂົ້າ ZJI */}
                  {
                    format(oneData.ZJIIncom)
                  }
                </td>
                <td style={{ textAlign: 'right' }}>
                  {/* ລາຍຮັບເຂົ້າ ZJI ສຸດທິ */}
                  {
                    format(oneData.ZJIIncom + oneData.depos)
                  }
                </td>
                <td>
                  {format(oneData.day)} ວັນ
                </td>
                <td>
                  {oneData.emp_paid === 1 ? (
                    <Tag style={{ cursor: "pointer" }} color="geekblue">
                      ການຊຳລະສົມບູນ
                    </Tag>
                  ) : (
                    <Tag style={{ cursor: "pointer" }} color="red">
                      ລໍຖ້າການຊຳລະ
                    </Tag>
                  )}
                </td>

                <td>
                  {/* {oneData.paid === 1 ? <Tag style={{ cursor: 'pointer' }} color="geekblue">ການຊຳລະສົມບູນ</Tag> : <Tag style={{ cursor: 'pointer' }} color="red">ລໍຖ້າການຊຳລະ</Tag>} */}
                  {oneData.paid === 1 ? (
                    <Tag
                      style={{ cursor: "pointer" }}
                      color="geekblue"
                      onClick={() => showModalDetail(oneData.no)}
                    >
                      ການຊຳລະສົມບູນ
                    </Tag>
                  ) : (
                    <Tag
                      style={{ cursor: "pointer" }}
                      color="red"
                      onClick={() => showModalDetail(oneData.no)}
                    >
                      ລໍຖ້າການຊຳລະ
                    </Tag>
                  )}
                </td>
                <td>
                  {oneData.cancel === 1 ? (
                    <Tag
                      style={{ cursor: "pointer" }}
                      onClick={() => handleClick(oneData.no)}
                      color="red"
                    >
                      ຖືກຍົກເລີກ
                    </Tag>
                  ) : (
                    <Tag
                      style={{ cursor: "pointer" }}
                      onClick={() => handleClick(oneData.no)}
                      color="geekblue"
                    >
                      ບໍ່ຖືກຍົກເລີກ
                    </Tag>
                  )}
                </td>
                <td>
                  <Button
                    danger
                    onClick={() => {
                      setno(oneData.no);
                      setenablePayLate(true);
                    }}
                    disabled={
                      oneData.paid === 1
                        ? true
                        : oneData.enable_pay_late === 1
                          ? true
                          : false
                    }
                  >
                    ຢືນຢັນການອະນຸຍາດ
                  </Button>
                </td>
              </tr>
            </tbody>
          )}
        </table>

        {/* ຟອມອະນຸຍາດໃຫ້ຈ່າຍຊ້າສັນຍາເລກທີ:  */}
        <Modal
          title={"ຟອມອະນຸຍາດໃຫ້ຈ່າຍຊ້າສັນຍາເລກທີ: " + no}
          visible={enablePayLate}
          onCancel={() => setenablePayLate(!enablePayLate)}
          footer={[
            <Button
              key="back"
              type="primary"
              onClick={() => setenablePayLate(!enablePayLate)}
            >
              ກັບຄືນ
            </Button>,
            detial !== "" && (
              <Button key="submit" danger onClick={() => confirmFullCommit()}>
                ຢືນຢັນອະນຸຍາດ
              </Button>
            ),
          ]}
        >
          <TextArea
            placeholder="ກະລຸນາໃສ່ລາຍລະອຽດ ການອະນຸຍາດໃຫ້ຈ່າຍຊ້າສັນຍາ"
            showCount
            maxLength={150}
            defaultValue={detial}
            onChange={(e) => setdetial(e.target.value)}
          />
        </Modal>
      </div>
    );
  }

  function handleClick(no) {
    window.open(QR + no);
  }
}

export default ConfirmPaidLate;




// function ShowModalPolicy(no, modal_show_alldetail, setmodal_show_alldetail, getOneFull) {
//   return (
//     <Modal
//       width={500}
//       title={"ລາຍລະອຽດຂອງສັນຍາເລກທີ " + pad(no)}
//       visible={modal_show_alldetail}
//       onOk={() => setmodal_show_alldetail(false)}
//       onCancel={() => setmodal_show_alldetail(false)}
//       footer={[
//         <Button key="back" onClick={() => setmodal_show_alldetail(false)}>
//           ກັບຄືນ
//         </Button>

//       ]}
//     >
//       <div className="row modalBox">
//         <div className="col">ຊື່ລູກຄ້າ</div>
//         <div className="col">{getOneFull.o_name}</div>
//       </div>
//       <div className="row modalBox">
//         <div className="col">ເບີໂທ</div>
//         <div className="col">{getOneFull.o_tel}</div>
//       </div>
//       <div className="row modalBox">
//         <div className="col">ເລກປ້າຍ</div>
//         <div className="col">{getOneFull.o_plate}</div>
//       </div>
//       <div className="row modalBox">
//         <div className="col">ເລກຈັກ</div>
//         <div className="col">{getOneFull.o_engine}</div>
//       </div>
//       <div className="row modalBox">
//         <div className="col">ເລກຖັງ</div>
//         <div className="col">{getOneFull.o_chassis}</div>
//       </div>
//       <div className="row modalBox">
//         <div className="col">ປະເພດລົດ</div>
//         <div className="col">{getOneFull.o_type}</div>
//       </div>
//       <div className="row modalBox">
//         <div className="col">ປະເພດການຄຸ້ມກັນ</div>
//         <div className="col">{getOneFull.cover}</div>
//       </div>
//       <div className="row modalBox">
//         <div className="col">ວັນທີເລີ່ມຄຸ້ມກັນ</div>
//         <div className="col">{moment(getOneFull.start).format('DD-MM-YYYY HH:mm:ss')}</div>
//       </div>
//       <div className="row modalBox">
//         <div className="col">ວັນທີສິນສຸດການຄຸ້ມກັນ</div>
//         <div className="col">{moment(getOneFull.end).format('DD-MM-YYYY HH:mm:ss')}</div>
//       </div>
//       <div className="row modalBox">
//         <div className="col">ຄ່າທຳນຽມທັງໝົ້ດ</div>
//         <div className="col">{format(getOneFull.total_premuim)}</div>
//       </div>
//       <div className="row modalBox">
//         <div className="col">ຄ່າທຳນຽມກ່ອນອາກອນ</div>
//         <div className="col">{format(getOneFull.premuim)}</div>
//       </div>
//       <div className="row modalBox">
//         <div className="col">{getOneFull.paid === 1 ?
//           "ເປີເຊັນການຂາຍ  " + getOneFull.commission_percen
//           :
//           "ເປີເຊັນການຂາຍ (ຄ່າຄອມ-ຈ່າຍຊ້າ) (" + format(getOneFull.Total_MVL) + "-" + getOneFull.paylate + ")"
//         }%</div>
//         <div className="col">{format(getOneFull.agentCommit)}</div>
//       </div>
//       <div className="row modalBox">
//         <div className="col">
//           ເງິນຝາກຄັງ
//         </div>
//         <div className="col">{format(getOneFull.Diposit)}% = {format(getOneFull.depos)}</div>
//       </div>
//       <div className="row modalBox">
//         <div className="col">{
//           "ຫັກອາກອນ"
//           + getOneFull.Text116
//           + "%"
//         } </div>
//         <div className="col">{format(getOneFull.tex)}</div>
//       </div>
//       <div className="row modalBox">
//         <div className="col">ລາຍຮັບເຂົ້າ ZJI</div>
//         <div className="col">{format(getOneFull.ZJIIncom)}</div>
//       </div>
//       <div className="row modalBox">
//         <div className="col">ລູກຄ້າຈາກຕົວແທນ</div>
//         <div className="col">{getOneFull.name}</div>
//       </div>
//       <div className="row modalBox">
//         <div className="col">ເຂົ້າສູ່ລະບົບວັນທີ</div>
//         <div className="col">{moment(getOneFull.dateadd).format('DD-MM-YYYY HH:mm:ss')}</div>
//       </div>
//       <div className="row modalBox">
//         <div className="col">ສະຖານະລູກຄ້າຊຳລະ</div>
//         <div className={getOneFull.emp_paid === 0 ? "col textRed" : "col"} >
//           {getOneFull.emp_paid === 0 ? 'ລໍຖ້າການຊຳລະ' : 'ການຊຳລະສົມບູນ'}
//         </div>
//       </div>
//       <div className="row modalBox">
//         <div className="col">ສະຖານະຕົວແທນຊຳລະ</div>
//         <div className={getOneFull.paid === 0 ? "col textRed" : "col"} >
//           {getOneFull.paid === 0 ?
//             'ລໍຖ້າການຊຳລະ'
//             :
//             'ການຊຳລະສົມບູນ ວັນທີ ' + moment(getOneFull.paid_date).format('DD-MM-YYYY HH:mm:ss')
//           }

//         </div>
//       </div>
//       <div className="row modalBox">
//         <div className="col">ສະຖານະການຍົກເລີກສັນຍາ</div>
//         <div className={getOneFull.cancel === 0 ? "col" : "col textRed"} >
//           {getOneFull.cancel === 0 ?
//             'ບໍ່ຖືກຍົກເລີກ'
//             :
//             'ຖືກຍົກ ວັນທີ ' + moment(getOneFull.cancel_date).format('DD-MM-YYYY HH:mm:ss')
//           }

//         </div>
//       </div>
//       <div className="row modalBox">
//         <div className="col">
//           ນະໂຍບາຍຈ່າຍຊ້າ
//         </div>
//         <div className={getOneFull.enable_pay_late === 0 ? "col" : "col textRed"} >
//           {getOneFull.enable_pay_late === 0 ?
//             'ບໍ່ອະນຸຍາດ'
//             :
//             'ອະນຸຍາດ'
//           }

//         </div>
//       </div>
//       <div className="row modalBox">
//         <div className="col">ໝາຍເຫດ</div>
//         <div className="col">
//           {getOneFull.detial}

//         </div>
//       </div>


//     </Modal>
//   )
// }
